import "../styles/Blog.css";
import allBlogs from "../data/blogsData";

function Blogs() {
    const blogList = allBlogs.map((blog) => {
        const bodyContent = Array.isArray(blog.body)
            ? blog.body.map(p => `<p>${p}</p>`).join('')
            : `<p>${blog.body.replace(/\n/g, '<br />')}</p>`;

        return (
            <div key={blog.id} className="BlogPost">
                <div className="BlogTitle">{blog.title}</div>
                <div className="BlogAuthor">By {blog.author}</div>
                <div className="BlogDate">Posted: {blog.dataCreated}</div>
                <div className="BlogBody" dangerouslySetInnerHTML={{ __html: bodyContent }} />
                <img src={blog.image} alt={blog.caption} className="BlogImage" />
                <div className="ImageCaption">{blog.caption}</div>
            </div>
        );
    })

    return (
        <div className="BlogsContainer">{blogList}</div>
    );
}

export default Blogs;